export default __webpack_public_path__ + "static/media/Greengram.ecf81e1b.jpg";